import { useDeviceType } from '../../../hooks/useDeviceType';
import { StarSmalls } from './StarSmalls';
import { Text as Paragraph } from '../../Typography';
import { AverageRating } from './AverageRating';

export interface IStarButtonContent {
  ratingValue: number;
  ratingTotal: number;
  ratingEn: string;
}

export const StarButtonContent = ({ ratingValue, ratingTotal, ratingEn }: IStarButtonContent) => {
  const { isMobile } = useDeviceType();
  const ratingToDisplay = ratingValue?.toFixed(1) || '0';

  const filledStarsCount = Math.round(ratingValue);
  const emptyStarsCount = 5 - filledStarsCount;

  const filledStars = Array.from({ length: filledStarsCount }, (_, i) => (
    <StarSmalls key={`filled-${i}`} isFilled />
  ));
  const emptyStars = Array.from({ length: emptyStarsCount }, (_, i) => (
    <StarSmalls key={`empty-${i}`} isFilled={false} />
  ));

  return (
    <>
      <span className="sr-only">{`Current rating ${ratingToDisplay}. Click to rate.`}</span>
      <Paragraph
        className="flex justify-center align-center leading-4.5 md:mb-1 m-px items-center"
        tag="div"
        type="leadxs"
      >
        {filledStars}
        {emptyStars}
        {ratingValue > 0 && !isMobile && <AverageRating rating={ratingToDisplay} />}
      </Paragraph>
      <Paragraph className="text-center md:mb-5 mb-3 text-gray-dark" tag="div" type="lead">
        {isMobile && (
          <>
            <AverageRating rating={ratingToDisplay} />[{ratingTotal} {ratingEn}]
          </>
        )}
        {!isMobile && (
          <>
            {ratingTotal} {ratingEn}
          </>
        )}
      </Paragraph>
    </>
  );
};
